module.exports = __webpack_public_path__ + "static/media/not-allowed.ef918eea.svg";